(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-new"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){ super(); }
  connectedCallback(){
    this.header = document.querySelector('.section-header');
    this.currentScrollTop = 0;
    window.addEventListener('scroll', this.onScroll.bind(this), false);
  }
  onScroll(){
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const atTop = scrollTop <= 2;
    this.header.classList.toggle('scrolled-past-header', !atTop);
    this.currentScrollTop = scrollTop;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }

    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight(){
      const h = this.header.offsetHeight || 64;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const atTop = scrollTop <= 2;
      this.header.classList.toggle('scrolled-past-header', !atTop);

      if (!atTop){
        if (scrollTop > this.currentScrollTop) {
          if (!this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
        } else {
          if (!this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky','animate');
            this.header.classList.remove('shopify-section-header-hidden');
          }
        }
      } else {
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
        }
      }

      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-landing-3"] && !Shopify.designMode) return;
  try {
    
/* Set a stable --fixvh based on window.innerHeight to stop iOS zoom/jump */
(function(){
  function setVH(){
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--fixvh', vh + 'px');
  }
  setVH();
  window.addEventListener('resize', setVH, { passive:true });
  window.addEventListener('orientationchange', setVH, { passive:true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-trueath"] && !Shopify.designMode) return;
  try {
    
/* Stabilize viewport height on iOS (same as original) */
(function(){
  function setVH(){ var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--fixvh', vh + 'px'); }
  setVH();
  window.addEventListener('resize', setVH, { passive:true });
  window.addEventListener('orientationchange', setVH, { passive:true });
})();

  } catch(e) { console.error(e); }
})();
})();
